<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="460"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="基地"
        prop="baseName"
      >
        <a-input
          v-model="form.baseName"
          placeholder="请填写基地名称"
        />
      </a-form-model-item>

      <a-form-model-item
        label="基地别名"
        prop="alias"
      >
        <a-input
          v-model="form.alias"
          placeholder="请填写基地别名"
        />
      </a-form-model-item>

      <a-form-model-item
        label="BD:"
        prop="bdName"
      >
        <a-input
          v-model="form.bdName"
          placeholder="请填写BD名"
        />
      </a-form-model-item>
      <a-form-model-item
        label="运营商公司:"
        prop="operatorCompany"
      >
        <a-input
          v-model="form.operatorCompany"
          placeholder="请填写运营商公司"
        />
      </a-form-model-item>
      <a-form-model-item
        label="基地配比系数"
        prop="ratio"
      >
        <a-input
          v-model="form.ratio"
          placeholder="请填写基地配比系数"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateBase, addBase } from '@/api/baseInfo'
import moment from 'moment'
import { deepClone } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: undefined,
        baseName: undefined,
        alias: undefined,
        bdName: undefined,
        operatorCompany: undefined,
        ratio: undefined
      },
      validateRules: {
        baseName: [{ required: true, message: '请输入基地' }],
        bdName: [{ required: true, message: '请输入BD名' }],
        operatorCompany: [{ required: true, message: '请输入运营商公司' }],
        ratio: [{ required: true, message: '请输入基地配比系数' }],
        alias: [{ required: true, message: '请输入别名' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY/MM'
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        this.form = this.deepClone(data)
      }
    }
  },
  methods: {
    moment,
    deepClone,
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.actionType === '0') {
            updateBase({
              ...this.form
            }
            )
              .then(() => {
                this.$message.success('提交成功')
                this.$emit('ok')
              })
          } else {
            addBase({
              ...this.form
            }
            )
              .then(() => {
                this.$message.success('提交成功')
                this.$emit('ok')
              })
          }
        }
      })
    }
  }
}

</script>
